import { Milliseconds } from '@kameleoon/javascript-sdk-core/browser';

export enum CookieParameter {
  PairsDelimiter = '; ',
  KeyValueDelimiter = '=',
  MaxAge = 'Max-Age',
  Path = 'Path',
  Domain = 'Domain',
}
export const ACTIVITY_INTERVAL = 15 * Milliseconds.Second;
export const VISIT_DURATION = 30 * Milliseconds.Minute;
